"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _activePortal = require("./activePortal.reducer");

Object.keys(_activePortal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _activePortal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _activePortal[key];
    }
  });
});